/*
 * @Author: chengyu
 * @Date: 2022-09-29 14:38:18
 * @Description: Taro适配
 * https://docs.taro.zone/docs/apis/network/request
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getContext } from '../../../config';
import { mapError, mapLog } from '../../../utils/logger';
import { getTrackParams, getTrackResponse, trackHttp, } from '../../../utils/ubt';
function adapter(request, responseCallback) {
    var baseParams = {
        method: request.method,
        url: request.url,
        data: request.body,
        header: request.headers,
        timeout: request.timeout,
        dataType: 'text',
        responseType: request.responseType,
    };
    var trackParams = getTrackParams(baseParams);
    var params = __assign(__assign({}, baseParams), { success: function (res) {
            responseCallback({
                statusCode: res.statusCode,
                responseText: res.data,
                headers: res.header,
                statusMessage: res.errMsg,
            });
            trackParams.success(getTrackResponse(res));
            mapLog('Taro adapter success', [res]);
        }, fail: function (res) {
            responseCallback({
                statusCode: 0,
                statusMessage: res.errMsg,
            });
            trackParams.fail(res);
            mapError('Taro adapter fail', res);
        } });
    trackHttp(trackParams);
    var context = getContext();
    context.request(params);
}
export default adapter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFyby5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb3JlL3JlcXVlc3QvaHR0cC9hZGFwdGVyL3Rhcm8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7O0dBS0c7Ozs7Ozs7Ozs7OztBQUtILE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUM3QyxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBQ3pELE9BQU8sRUFDTCxjQUFjLEVBQ2QsZ0JBQWdCLEVBQ2hCLFNBQVMsR0FDVixNQUFNLG9CQUFvQixDQUFDO0FBZ0M1QixTQUFTLE9BQU8sQ0FDZCxPQUF5QixFQUN6QixnQkFBeUM7SUFFekMsSUFBTSxVQUFVLEdBQUc7UUFDakIsTUFBTSxFQUFFLE9BQU8sQ0FBQyxNQUFNO1FBQ3RCLEdBQUcsRUFBRSxPQUFPLENBQUMsR0FBRztRQUNoQixJQUFJLEVBQUUsT0FBTyxDQUFDLElBQUk7UUFDbEIsTUFBTSxFQUFFLE9BQU8sQ0FBQyxPQUFPO1FBQ3ZCLE9BQU8sRUFBRSxPQUFPLENBQUMsT0FBTztRQUN4QixRQUFRLEVBQUUsTUFBTTtRQUNoQixZQUFZLEVBQUUsT0FBTyxDQUFDLFlBQVk7S0FDbkMsQ0FBQztJQUNGLElBQU0sV0FBVyxHQUFHLGNBQWMsQ0FBQyxVQUFVLENBQUMsQ0FBQztJQUMvQyxJQUFNLE1BQU0seUJBQ1AsVUFBVSxLQUNiLE9BQU8sWUFBQyxHQUFzQjtZQUM1QixnQkFBZ0IsQ0FBQztnQkFDZixVQUFVLEVBQUUsR0FBRyxDQUFDLFVBQVU7Z0JBQzFCLFlBQVksRUFBRSxHQUFHLENBQUMsSUFBSTtnQkFDdEIsT0FBTyxFQUFFLEdBQUcsQ0FBQyxNQUFNO2dCQUNuQixhQUFhLEVBQUUsR0FBRyxDQUFDLE1BQU07YUFDMUIsQ0FBQyxDQUFDO1lBQ0gsV0FBVyxDQUFDLE9BQU8sQ0FBQyxnQkFBZ0IsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO1lBQzNDLE1BQU0sQ0FBQyxzQkFBc0IsRUFBRSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7UUFDeEMsQ0FBQyxFQUNELElBQUksWUFBQyxHQUFtQjtZQUN0QixnQkFBZ0IsQ0FBQztnQkFDZixVQUFVLEVBQUUsQ0FBQztnQkFDYixhQUFhLEVBQUUsR0FBRyxDQUFDLE1BQU07YUFDMUIsQ0FBQyxDQUFDO1lBQ0gsV0FBVyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztZQUN0QixRQUFRLENBQUMsbUJBQW1CLEVBQUUsR0FBRyxDQUFDLENBQUM7UUFDckMsQ0FBQyxHQUNGLENBQUM7SUFDRixTQUFTLENBQUMsV0FBVyxDQUFDLENBQUM7SUFDdkIsSUFBTSxPQUFPLEdBQUcsVUFBVSxFQUFFLENBQUM7SUFDN0IsT0FBTyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQztBQUMxQixDQUFDO0FBRUQsZUFBZSxPQUFPLENBQUMifQ==